import { useBreakpointsContext } from '@air/provider-media-query';

export const useShowUI2Page = () => {
  const { isAboveMediumScreen } = useBreakpointsContext();

  return {
    showUI2: isAboveMediumScreen,
  };
};
